import { styled } from 'src/modules';

export const Line = styled.hr`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.line};
`;
